/**
 * An API refusal while starting a guest session, carrying the API's error
 * code so the form can offer the right next step (a CREDITS_EXHAUSTED device
 * refusal needs sign-in / sign-up links, not just red text). Lives outside
 * GuestContext so components and tests can import it without the provider.
 */
export class GuestSessionError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'GuestSessionError';
  }
}
